<template>
  <div class="captcha-wrapper">
    <vue-recaptcha
      ref="invisibleRecaptcha"
      recaptchaHost="www.recaptcha.net"
      size="invisible"
      :sitekey="recaptchaSitekey"
      :loadRecaptchaScript="true"
      @verify="onCaptchaVerify"
      @expired="onCaptchaExpire"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'CaptchaBlock',
  components: {
    VueRecaptcha,
  },
  props: {
    keyType: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      isComponentLoading: state => state.app.isComponentLoading,
      isLoadingCaptcha: state => state.app.isLoadingCaptcha,
    }),
    recaptchaSitekey() {
      let keyTypeValue = ''
      switch (this.keyType) {
        case 'login':
          keyTypeValue = process.env.VUE_APP_RECAPTCHA_SITEKEY
          break
        case 'registration':
          keyTypeValue = process.env.VUE_APP_RECAPTCHA_NON_INVISIBLE_SITEKEY
          break
        case 'subscriptions':
          keyTypeValue = process.env.VUE_APP_INVISIBLE_SUBSCRIPTIONS_RECAPTCHA_SITEKEY
          break
      }
      return keyTypeValue
    },
  },
  methods: {
    ...mapActions({
      setIsLoadingCaptcha: 'app/setIsLoadingCaptcha',
    }),
    execute() {
      this.setIsLoadingCaptcha(true)
      this.$refs.invisibleRecaptcha.execute()
    },
    onCaptchaVerify(recaptcha) {
      this.$emit('captcha-verify-action', { recaptcha })
      this.setIsLoadingCaptcha(false)
      this.$refs.invisibleRecaptcha.reset()
    },
    onCaptchaExpire() {
      this.$refs.invisibleRecaptcha.reset()
    },
  },
}
</script>

<style lang="scss">
.captcha-wrapper {
  display: none;
}
</style>
